import apiClient from 'ps-components/lib/apiClient';

export const ADD_OR_REMOVE_SURVEY_JOB = 'ADD_OR_REMOVE_SURVEY_JOB';
export const ADD_OR_REMOVE_SURVEY_JOB_BY_CODE = 'ADD_OR_REMOVE_SURVEY_JOB_BY_CODE';
export const BULK_SELECT_SURVEY_JOB_CODES = 'BULK_SELECT_SURVEY_JOB_CODES';
export const BULK_SELECT_SURVEY_JOBS = 'BULK_SELECT_SURVEY_JOBS';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';
export const CLEAR_SELECTED_SURVEY_JOBS = 'CLEAR_SELECTED_SURVEY_JOBS';
export const PROPAGATE_MATCHES_ERROR = 'PROPAGATE_MATCHES_ERROR';
export const PROPAGATE_MATCHES_SUCCESS = 'PROPAGATE_MATCHES_SUCCESS';
export const SET_SURVEY_JOB_FACET_TEXT = 'SET_SURVEY_JOB_FACET_TEXT';
export const START_PROPAGATE_MATCHES = 'START_PROPAGATE_MATCHES';
export const TOGGLE_SHOW_SELECTED_SURVEY_JOBS = 'TOGGLE_SHOW_SELECTED_SURVEY_JOBS';

export function addOrRemoveSurveyJob(id) {
  return dispatch => {
    dispatch({
      type: ADD_OR_REMOVE_SURVEY_JOB,
      id
    });
  };
}

export function addOrRemoveSurveyJobByCode(surveyJobCode, surveyCode, matchId) {
  return dispatch => {
    dispatch({
      type: ADD_OR_REMOVE_SURVEY_JOB_BY_CODE,
      data: {
        surveyJobCode,
        surveyCode,
        matchId
      }
    });
  };
}

export function bulkSelectSurveyJobCodes(jobs) {
  return dispatch => {
    dispatch({
      type: BULK_SELECT_SURVEY_JOB_CODES,
      jobs
    });
  };
}

// jobs will either be a list of all the survey job matches,
// or an empty array
export function bulkSelectSurveyJobs(jobs) {
  return dispatch => {
    dispatch({
      type: BULK_SELECT_SURVEY_JOBS,
      jobs
    });
  };
}

export function clearSelectedSurveyJobs() {
  return dispatch => {
    dispatch({
      type: CLEAR_SELECTED_SURVEY_JOBS
    });
  };
}

export function clearSurveyJobSearch(currency) {
  return async dispatch => {
    dispatch({
      type: CLEAR_SEARCH
    });
  };
}

export function propagateMatches(orgJobCode, propagateToKeys, surveyJobs, method) {
  return async dispatch => {
    try {
      dispatch({
        type: START_PROPAGATE_MATCHES
      });

      const response = await apiClient.apiPost('/api/market-pricing/global-job-matching/propagateMatches', {
        orgJobCode,
        propagateToKeys,
        method,
        surveyJobs
      });

      dispatch({
        type: PROPAGATE_MATCHES_SUCCESS,
        propagatedMatches: response.data.propagatedMatches
      });
    } catch (err) {
      console.error('Error trying to propagate matches: ', err);
      dispatch({
        type: PROPAGATE_MATCHES_ERROR,
        msg: err
      });
    }
  };
}

export function setSurveyJobFacetText(text) {
  return async dispatch => {
    dispatch({
      type: SET_SURVEY_JOB_FACET_TEXT,
      data: text
    });
  };
}

export function toggleShowSelectedSurveyJobs() {
  return { type: TOGGLE_SHOW_SELECTED_SURVEY_JOBS };
}
